function init() {
  const canvas = document.getElementById('ambient-lights')
  const ctx = canvas.getContext('2d')

  canvas.width = window.innerWidth
  canvas.height = window.innerHeight

  let lightPositions = [
    {
      x: 0,
      y: canvas.height * 0.5,
      color: 'rgba(255, 0, 0, 0.4)',
      velocity: 3,
    }, // Left
    {
      x: canvas.width,
      y: canvas.height * 0.5,
      color: 'rgba(0, 50, 220, 0.4)',
      velocity: -3,
    }, // Right
  ]

  // Reduced lightRadius to make the spread smaller.
  const lightRadius = Math.max(canvas.width, canvas.height) * 0.8

  function drawLights() {
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    lightPositions.forEach((light) => {
      // Create gradient
      const gradient = ctx.createRadialGradient(
        light.x,
        light.y,
        0,
        light.x,
        light.y,
        lightRadius
      )
      gradient.addColorStop(0, light.color)
      gradient.addColorStop(1, 'rgba(0,0,0,0)') // Fade out to base color

      ctx.fillStyle = gradient
      ctx.beginPath()
      ctx.arc(light.x, light.y, lightRadius, 0, Math.PI * 2)
      ctx.fill()
    })
  }

  function updateLights() {
    lightPositions.forEach((light) => {
      light.y += light.velocity

      if (light.y > canvas.height * 0.9 || light.y < canvas.height * 0.1) {
        light.velocity *= -1
      }
    })
  }

  function animate() {
    drawLights()
    updateLights()
    requestAnimationFrame(animate)
  }
  animate()

  window.addEventListener('resize', () => {
    canvas.width = window.innerWidth
    canvas.height = window.innerHeight

    lightPositions = [
      {
        x: 0,
        y: canvas.height * 0.5,
        color: 'rgba(255, 0, 0, 0.4)',
        velocity: 3,
      }, // Left
      {
        x: canvas.width,
        y: canvas.height * 0.5,
        color: 'rgba(0, 50, 220, 0.4)',
        velocity: -3,
      }, // Right
    ]
    drawLights()
  })
}

export default init
